import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyMagicLink } from '../../../services/api';
import { useStore } from '../../../store/useStore';
import routes from '../../../constants/routes';
import styled from 'styled-components';
import { trackEvent } from '../../../services/analytics';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #0a0a0a;
  color: #fff;
`;

const Card = styled.div`
  text-align: center;
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 0 0 1rem 0;
`;

const Message = styled.p<{ $error?: boolean }>`
  font-size: 0.8rem;
  color: ${({ $error }) => ($error ? '#f87171' : 'rgba(255, 255, 255, 0.6)')};
`;

export const AuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const verify = async () => {
      trackEvent('auth_callback_started');
      const email = searchParams.get('email');
      const token = searchParams.get('token');

      if (!email || !token) {
        trackEvent('auth_callback_invalid_link');
        setStatus('error');
        setErrorMessage('Invalid magic link');
        return;
      }

      try {
        trackEvent('magic_link_verify_attempt');
        await verifyMagicLink(decodeURIComponent(email), token);
        trackEvent('magic_link_verify_success');
        await useStore.getState().initialize();
        setStatus('success');
        setTimeout(() => {
          navigate(routes.LANDING, { replace: true });
        }, 1500);
      } catch (err) {
        trackEvent('magic_link_verify_error');
        setStatus('error');
        setErrorMessage(err instanceof Error ? err.message : 'Verification failed');
      }
    };

    verify();
  }, [searchParams, navigate]);

  return (
    <Container>
      <Card>
        {status === 'loading' && (
          <>
            <Title>verifying</Title>
            <Message>please wait...</Message>
          </>
        )}
        {status === 'success' && (
          <>
            <Title>verified</Title>
            <Message>redirecting to terminal...</Message>
          </>
        )}
        {status === 'error' && (
          <>
            <Title>error</Title>
            <Message $error>{errorMessage}</Message>
          </>
        )}
      </Card>
    </Container>
  );
};
